<div class="header-bar">
  <h1>Additional Charges - More Information Requests</h1>
</div>
<div class="content-container">
  <div class="text-center p-5" *ngIf="!isLoaded">
    <i class="fa fa-spin fa-spinner fa-2x"></i>
  </div>

  <div *ngIf="isLoaded && additionalChargeQuestions.length > 0">
    <p-table
      [value]="additionalChargeQuestions"
      [paginator]="true"
      [rows]="10"
      selectionMode="single"
      [(selection)]="responseSelected"
      [totalRecords]="additionalChargeQuestions.length"
      [hidden]="!isLoaded"
    >
      <ng-template pTemplate="header">
        <tr>
          <th pSortableColumn="headline">
            Summary
            <i
              class="fa fa-exclamation-circle"
              pTooltip="Internal name for reason, not shown to Supplier"
            ></i>
          </th>
          <th pSortableColumn="senderName">Sender Name</th>
          <th pSortableColumn="senderAddress">Sender Address</th>
          <th pSortableColumn="added" style="width: 150px">Added</th>
        </tr>
      </ng-template>

      <ng-template pTemplate="body" let-item>
        <tr (dblclick)="editResponse(item)" [pSelectableRow]="item">
          <td>{{ item.headline }}</td>
          <td>{{ item.senderNameTemplate }}</td>
          <td>{{ item.senderAddressTemplate }}</td>
          <td class="text-center">{{ item.added | datex : 'DD/MM/YY HH:mm' }}</td>
        </tr>
      </ng-template>
    </p-table>
  </div>

  <div class="ui-g">
    <div class="ui-g-12">
      <button
        *ngIf="responseSelected != null"
        pButton
        type="button"
        label="Delete"
        class="ui-button ui-button-danger btn-to-right pull-right"
        (click)="deleteQuestion()"
      ></button>

      <button
        *ngIf="responseSelected != null"
        pButton
        type="button"
        label="Edit"
        class="ui-button ui-button-default btn-to-right pull-right"
        (click)="editResponse(responseSelected)"
      ></button>

      <button
        pButton
        type="button"
        label="Create Request Template"
        class="ui-button ui-button-success btn-to-right pull-right"
        (click)="createQuestion()"
      ></button>
    </div>
  </div>
</div>

<p-confirmDialog
  header="Confirmation"
  icon="fa-icon-circle"
  [style]="{ width: '425px' }"
  acceptLabel="Confirm"
  rejectLabel="Cancel"
></p-confirmDialog>

<p-dialog
  [header]="editMode ? 'Edit More Information Response' : 'Create More Information Response'"
  [(visible)]="showEditForm"
  [responsive]="true"
  [modal]="true"
  [style]="{ width: '600px' }"
>
  <form [formGroup]="editForm" *ngIf="showEditForm">
    <div class="ui-g">
      <div class="ui-g-4">
        <input type="hidden" formControlName="id" />
        <div class="input-label">
          Summary
          <i
            class="fa fa-exclamation-circle"
            pTooltip="Internal name for reason, not shown to Supplier"
          ></i>
        </div>
        <div class="input-value">
          <input
            required
            pInputText
            formControlName="headline"
            maxlength="30"
            style="width: 100%"
          />
        </div>
      </div>
      <div class="ui-g-8">
        <div class="input-label">Wrapper Template</div>

        <div class="input-value">
          <p-dropdown [options]="wrapperOptions" formControlName="templateWrapperId"></p-dropdown>
        </div>
      </div>

      <div class="ui-g-12">
        <div class="input-label">Recipent E-mail Address</div>
        <div class="input-value">
          <input
            required
            pInputText
            formControlName="recipientAddressTemplate"
            style="width: 100%"
          />
        </div>

        <div class="input-label">E-mail Subject Line</div>
        <div class="input-value">
          <input required pInputText formControlName="subjectTemplate" style="width: 100%" />
        </div>

        <div class="input-label">E-mail Body</div>
        <div class="input-value">
          <textarea
            pInputTextarea
            formControlName="bodyTemplate"
            style="width: 100%; height: 150px"
          ></textarea>
        </div>
      </div>
    </div>

    <div class="ui-g">
      <div class="ui-g-12 ui-md-6">
        <div class="input-label">Sender E-mail</div>
        <div class="input-value">
          <input
            pInputText
            type="email"
            formControlName="senderAddressTemplate"
            style="width: 100%"
          />
        </div>

        <div class="input-label">Sender Name</div>
        <div class="input-value">
          <input pInputText formControlName="senderNameTemplate" style="width: 100%" />
        </div>
      </div>

      <div class="ui-g-12 ui-md-6">
        <div class="input-label">ReplyTo E-mail</div>
        <div class="input-value">
          <input
            pInputText
            [placeholder]="editForm.get('senderAddressTemplate').value"
            type="email"
            formControlName="replyToAddressTemplate"
            style="width: 100%"
          />
        </div>

        <div class="input-label">ReplyTo Name</div>
        <div class="input-value">
          <input
            pInputText
            [placeholder]="editForm.get('senderNameTemplate').value"
            formControlName="replyToNameTemplate"
            style="width: 100%"
          />
        </div>
      </div>

      <div class="d-flex w-100">
        <div class="flex-shrink-1 pl-2" style="line-height: 33px" (click)="showHelp = !showHelp">
          <i class="fa fa-question-circle"></i>
          <span style="display: inline-block; line-height: 33px; margin-left: 5px">Help</span>
        </div>
        <div class="flex-grow-1 text-right">
          <button
            pButton
            type="button"
            label="Cancel"
            class="ui-button ui-button-default"
            (click)="showEditForm = false"
          ></button>

          <button
            pButton
            type="button"
            label="Save"
            [disabled]="!editForm.valid"
            class="ui-button ui-button-success btn-green"
            (click)="saveResponse()"
          ></button>
        </div>
      </div>
    </div>
  </form>
  <div *ngIf="showHelp" class="p-2">
    <div>Available models (No need for nested syntax, eg. task.order.job)</div>
    <div class="pt-2">
      <div class="d-flex grid-gap-10 w-100" style="font-weight: bold">
        <div>AdditionalCharge</div>
        <div>Task</div>
        <div>Order</div>
        <div>Job</div>
        <div>Supplier</div>
        <div>User</div>
      </div>
    </div>

    <div class="pt-2">NOTE: Pascal case fields should be entered as Snake Case</div>
    <div class="pt-2">eg. JobNumber should be job_number</div>
    <div class="pt-3">
      More information on
      <a _target="_new" href="https://shopify.github.io/liquid/">Liquid syntax</a>
    </div>
  </div>
</p-dialog>
